import React from "react";
import PropTypes from "prop-types";
import { MathJax } from "better-react-mathjax";
import DcsdDialog from "../modals/DcsdDialog";
import ActionButton from "../formInputs/buttons/ActionButton";
import TextField from "../formInputs/TextField";
import { getColorClass, RATING_DISPLAY_LABELS } from "../../utils/InputRatingUtils";

import "../../styles/RatingTable.scss";

const RatingTableModal = ({ open, onClose, onSave, context, setContext }) => {
    if (!context) return null;

    const { student, contentItem, rating, comment } = context;
    const disableSave = !rating || student.isDisabled || comment.trim().length === 0;

    return (
        <DcsdDialog
            id="rating-comment-modal"
            ariaLabel="Edit Rating Comment"
            title={`Edit Comment for ${student?.firstName} ${student?.lastName}`}
            open={open ? "rating-comment-modal" : ""}
            onHide={onClose}
            hasCloseX
            actions={
                <>
                    <ActionButton className="action-button-cancel" label="Cancel" onClick={onClose} />
                    <ActionButton disable={disableSave} label="Save Comment" onClick={onSave} />
                </>
            }
        >
            <div className="rating-comment-model">
                <div className="section-spacing">
                    <MathJax hideUntilTypeset={"first"} tabIndex={-1}>
                        <strong>Content Item:</strong> <span dangerouslySetInnerHTML={{ __html: contentItem.label }} />
                    </MathJax>
                </div>
                <div className="section-spacing">
                    <strong>Current Rating:</strong>{" "}
                    <span className={`${getColorClass(rating)}-comment`}>{RATING_DISPLAY_LABELS[rating] || "--"}</span>
                </div>
                <div className="section-spacing">
                    <strong>Content Item Rating Comment:</strong>
                    <TextField
                        charsUsed={comment.length}
                        className="form-control"
                        disabled={student.isDisabled}
                        maxLimit={7500}
                        name="body"
                        id="subject"
                        onChange={(e) => setContext({ ...context, comment: e.target.value })}
                        placeholder="Please add your comment"
                        value={comment}
                    />
                </div>
                {(!rating || student.isDisabled) && (
                    <div className="error-container">
                        {student.isDisabled && (
                            <span className="error-text">You do not have edit permission for this student.</span>
                        )}
                        {!rating && !student.isDisabled && (
                            <span className="error-text">Content item must have a rating to add a comment.</span>
                        )}
                    </div>
                )}
            </div>
        </DcsdDialog>
    );
};

RatingTableModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    context: PropTypes.shape({
        student: PropTypes.object,
        contentItem: PropTypes.object,
        rating: PropTypes.string,
        comment: PropTypes.string
    }),
    setContext: PropTypes.func.isRequired
};

export default RatingTableModal;
